import nonEmptyString from './nonEmptyStringValidator.js'

// Note that this file mirrors a validation rule in the backend

export default function (input) {
    const regex = /^[a-zA-Z0-9 \-æÆøØåÅéÉëËöÖóÓáÁäÄüÜúÚ\.]+$/
    const whitespaceRegex = /^\s*$/
    return nonEmptyString(input) && !!input.match(regex) && !input.match(whitespaceRegex)
}
